module.exports = __webpack_public_path__ + "img/flag-2.4cf3a79a.svg";